import { render, staticRenderFns } from "./lta.vue?vue&type=template&id=9c9c89e4&scoped=true"
import script from "./lta.vue?vue&type=script&lang=js"
export * from "./lta.vue?vue&type=script&lang=js"
import style0 from "./lta.vue?vue&type=style&index=0&id=9c9c89e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9c89e4",
  null
  
)

export default component.exports